import { CSSObject } from '@chakra-ui/react';

export const BadgeCountdown = (
  state: 'inprogress' | 'prior' | 'ended'
): CSSObject => ({
  '&&&&': {
    bg: () => {
      if (state === 'inprogress') {
        return 'gamma.400';
      }
      if (state === 'ended') {
        return 'red.500';
      }
      // 'prior'
      return 'beta.500';
    },
    color: () => {
      if (state === 'inprogress') {
        return 'blackAlpha.700';
      }
      if (state === 'ended') {
        return 'white';
      }
      // 'prior'
      return 'blackAlpha.700';
    },
    borderRadius: '3px',
    px: 1,
    fontFamily: 'accent',
    fontWeight: 'bold',
    textTransform: 'capitalize',
  },
  '&&': {
    h: '16px',
    maxH: '16px',
    minH: '16px',
    lineHeight: '16px',
  },
});
